<template>
  <div class="account-agreement-awaiting view">
    <Card class="account-agreement-awaiting__widget">
      <template #header>
        <FontAwesomeIcon :icon="['fal', 'lock']" size="2x" />
        <h1>{{ $t('awaitingContractContractHeader') }}</h1>
      </template>
      <template #default>
        <div class="text--center">
          <p>{{ $t('awaitingContractMessage') }}</p>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import Card from '@/components/Card'

export default {
  metaInfo() {
    return {
      title: this.$t('noContracts'),
    }
  },
  components: {
    Card,
  },
}
</script>

<style lang="scss">
.account-agreement-awaiting {
  background-color: $background-grey;
  display: flex;
  justify-content: center;
  align-items: center;

  h1 {
    margin: 1rem 0 0 0;
    font-size: 1.5rem;
  }

  &__widget {
    flex-grow: 1;
    max-width: 400px;
  }
}
</style>
